import React, { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import Validationtip from '../../../validationtip/Validationtip';

interface TableCellIntegerProps {
  name: string;
  value: string;
  tableName?: string;
  onChangeHandler?: any;
  onFocusHandler?: any;
  onClickHandler?: any;
  rowIndex?: number;
  tabIndex?: number;
  onBlurHandler?: any;
  disabled?: boolean;
  allowNegative?: boolean;
  required?: boolean;
}

/**
 * Komponente für jede einzelene Zelle einer {@link Table.jsx}
 *
 * @param name - Html Name des Elementes
 * @param value Html Value des Elementes
 * @param changeHandler  on change handler
 * @param onFocusHandler  on focus handler
 * @param onClickHandler on click handler
 * @param rowIndex Zeilenindex
 * @param tabIndex tab index (auch -1 or 0), definiert die Tabreihenfolge
 * @param onBlurHandler on blur handler
 * @param disabled ob das Feld nicht aktiviert ist
 * @param allowNegative ob negative Werte erlaubt sind
 * @returns {JSX.Element}
 * @constructor
 */
const TableCellInteger = ({
  name,
  value,
  tableName,
  onChangeHandler,
  onFocusHandler,
  onClickHandler,
  rowIndex,
  tabIndex = 0,
  onBlurHandler,
  disabled,
  allowNegative = false,
  required = false,
}: TableCellIntegerProps) => {
  let numberFormatValue: any = undefined;

  useEffect(() => {
    //rerender
  }, [value]);

  /**
   * Definiert die Aktion, die ausgeführt wird, wenn sich das Element verändert.
   * @see https://developer.mozilla.org/de/docs/Web/API/HTMLElement/change_event
   *
   * @param event Html Event
   */
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!!numberFormatValue && !disabled)
      onChangeHandler(event.target.name, numberFormatValue.value, rowIndex);
  };

  /**
   * OnClick-Handler.
   * Definiert die Aktion, die ausgeführt wird, wenn das Element angeklickt wurde.
   */
  const onClick = () => {
    if (onClickHandler) {
      onClickHandler(rowIndex);
    }
  };

  /**
   * OnBlur-Handler.
   * Definiert die Aktion, die ausgeführt wird, nachdem das Element seinen Fokus verloren hat.
   * @param event
   */
  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlurHandler(rowIndex, event.target.name);
  };

  const MAX_VAL = 90000000.0;
  const withValueLimit = (inputObj: any) => {
    const { value } = inputObj;
    if (value < MAX_VAL) return inputObj;
  };

  /**
   * OnFocus-Handler.
   * Definiert die Aktion, die ausgeführt wird, wenn sich das Element im Fokus befindet.
   */
  const onFocus = () => {
    if (onFocusHandler) {
      onFocusHandler();
    }
  };

  return (
    <Validationtip
      fieldName={
        tableName && name ? tableName + '[' + rowIndex + '].' + name : ''
      }
    >
      <NumberFormat
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onClick={onClick}
        contentEditable={!disabled}
        placeholder=' '
        tabIndex={tabIndex}
        value={value}
        thousandSeparator={'.'}
        decimalSeparator={','}
        prefix={''}
        suffix={''}
        isNumericString={true}
        decimalScale={0}
        onValueChange={values => {
          numberFormatValue = values;
        }}
        allowNegative={allowNegative}
        isAllowed={withValueLimit}
        readOnly={disabled}
        required={required}
        autoComplete={'off'}
      />
    </Validationtip>
  );
};
export default TableCellInteger;
